let inputs = {
  name: {
    id: 'f',
    name: 'name',
    input: 'textField',
    label: 'inventoryList.form.name.label',
    placeholder: 'inventoryList.form.name.placeholder',
    rules: {
      required: { value: true },
    },
  },
  description: {
    id: 'description',
    name: 'description',
    input: 'textField',
    label: 'inventoryList.form.description.label',
    placeholder: 'inventoryList.form.description.placeholder'
  },
  company: {
    id: 'company',
    name: 'company',
    input: 'select',
    label: 'inventoryList.form.company.label',
    helperText: 'inventoryList.form.company.helperText',
  },
  type: {
    id: 'type',
    name: 'type',
    input: 'select',
    label: 'inventoryList.form.inventoryType.label'
  },
  additionalVariables: {
    id: 'additionalVariables',
    name: 'additionalVariables',
    label: 'inventoryList.form.variables.label',
    helperText: 'inventoryList.form.variables.helperText',
  },
  tags: {
    id: 'tags',
    name: 'tags',
    type: 'array',
    input: 'textField',
    label: 'inventoryList.form.tags.label',
    placeholder: 'inventoryList.form.tags.placeholder',
  },
  fromEdit: {
    id: 'fromEdit',
    name: 'fromEdit',
  },
  baseUrl: {
    id: 'baseUrl',
    name: 'baseUrl',
  },
  hosts: {
    id: 'hosts',
    type: 'array',
    name: 'hosts',
  },
  hostGroups: {
    id: 'hostGroups',
    type: 'array',
    name: 'hostGroups',
  },
  childrenGroups: {
    id: 'childrenGroups',
    type: 'array',
    name: 'childrenGroups',
  },
  modalHostName: {
    id: 'modalHostName',
    name: 'modalHostName',
    input: 'textField',
    label: 'inventoryList.form.modalHostName.label',
    placeholder: 'inventoryList.form.modalHostName.placeholder',
    rules: {
      required: {value: true}
    },
  },
  modalGroupName: {
    id: 'modalGroupName',
    name: 'modalGroupName',
    input: 'textField',
    label: 'inventoryList.form.modalGroupName.label',
    placeholder: 'inventoryList.form.modalGroupName.placeholder',
    rules: {
      required: {value: true}
    },
  },
  modalIpAddress: {
    id: 'modalIpAddress',
    name: 'modalIpAddress',
    input: 'textField',
    label: 'inventoryList.form.modalIpAddress.label',
    placeholder: 'inventoryList.form.modalIpAddress.placeholder',
    rules: {
      required: {value: true},
    },
  },
  modalTags: {
    id: 'modalTags',
    name: 'modalTags',
    type: 'array',
    input: 'textField',
    label: 'inventoryList.form.modalTags.label',
    placeholder: 'inventoryList.form.modalTags.placeholder',
  },
  modalNetworkType: {
    id: 'modalNetworkType',
    name: 'modalNetworkType',
    input: 'textField',
    label: 'inventoryList.form.modalNetworkType.label',
    placeholder: 'inventoryList.form.modalNetworkType.placeholder'
  },
  modalIsActive: {
    id: 'modalIsActive',
    name: 'modalIsActive',
    input: 'checkbox',
    label: 'inventoryList.form.modalIsActive.label',
  },
  modalVariables: {
    id: 'modalVariables',
    name: 'modalVariables',
    label: 'inventoryList.form.modalVariables.label',
    helperText: 'inventoryList.form.variables.helperText',
  },
  modalGroupHosts: {
    id: 'modalGroupHosts',
    input: 'selectChip',
    name: 'modalGroupHosts',
    label: 'inventoryList.form.modalGroupHosts.label',
  },
  modalGroups: {
    id: 'modalGroups',
    type: 'array',
    name: 'modalGroups',
  },
  modalGroupDescription: {
    id: 'modalGroupDescription',
    name: 'modalGroupDescription',
    input: 'textField',
    label: 'inventoryList.form.modalGroupDescription.label',
    placeholder: 'inventoryList.form.modalGroupDescription.placeholder',
  },
  modalChildrenGroupName: {
    id: 'modalChildrenGroupName',
    name: 'modalChildrenGroupName',
    input: 'textField',
    label: 'inventoryList.form.modalChildrenGroupName.label',
    placeholder: 'inventoryList.form.modalChildrenGroupName.placeholder',
    rules: {
      required: {value: true}
    },
  },
  modalChildrenGroupDescription: {
    id: 'modalChildrenGroupDescription',
    name: 'modalChildrenGroupDescription',
    input: 'textField',
    label: 'inventoryList.form.modalChildrenGroupDescription.label',
    placeholder: 'inventoryList.form.modalChildrenGroupDescription.placeholder',
  },
  modalChildrenGroupHosts: {
    id: 'modalChildrenGroupHosts',
    input: 'selectChip',
    name: 'modalChildrenGroupHosts',
    label: 'inventoryList.form.modalChildrenGroupHosts.label',
  }
}
const oldVersionApi = JSON.parse(process.env.REACT_APP_OLD_VERSION_API || false) || false;

if (oldVersionApi) {
  //TODO: DELETE THIS PLEASE >:l
  inputs = {
    name: {
      id: 'f',
      name: 'name',
      input: 'textField',
      label: 'inventoryList.form.name.label',
      placeholder: 'inventoryList.form.name.placeholder',
      rules: {
        required: { value: true },
      },
    },
    project: {
      id: 'project',
      name: 'project',
      input: 'select',
      label: 'inventoryList.form.project.label',
      helperText: 'inventoryList.form.project.helperText',
    },
    additionalVariables: {
      id: 'txt',
      name: 'additionalVariables',
      label: 'inventoryList.form.variables.label',
      helperText: 'inventoryList.form.variables.helperText',
    },
    fromEdit: {
      id: 'fromEdit',
      name: 'fromEdit',
    },
    baseUrl: {
      id: 'baseUrl',
      name: 'baseUrl',
    }
  }
}

export default inputs;
